// extracted by mini-css-extract-plugin
module.exports = {"LawElements":"LawLimits_LawElements__3G20b","LawElement":"LawLimits_LawElement__2WngO"};